import { trigger, state, style, transition, animate, animateChild, query } from '@angular/animations';


export const onSideNavChange = trigger('onSideNavChange', [
    state('collapse',
        style({
            'min-width': '0px'
        })
    ),
    state('close',
        style({
            'min-width': '50px'
        })
    ),
    state('open',
        style({
            'min-width': '300px'
        })
    ),
    transition('close => open', animate('250ms ease-in')),
    transition('open => close', animate('250ms ease-in')),
    transition('close => collapse', animate('0ms ease-in')),
    transition('collapse => close', animate('0ms ease-in')),
    transition('collapse => open', animate('0ms ease-in')),
    transition('open => collapse', animate('0ms ease-in')),
]);


export const onMainContentChange = trigger('onMainContentChange', [
    state('collapse',
        style({
            'margin-left': '0px'
        })
    ),
    state('close',
        style({
            'margin-left': '62px'
        })
    ),
    state('open',
        style({
            'margin-left': '300px'
        })
    ),
    transition('close => open', animate('250ms ease-in')),
    transition('open => close', animate('250ms ease-in')),
    transition('close => collapse', animate('0ms ease-in')),
    transition('collapse => close', animate('0ms ease-in')),
    transition('open => collapse', animate('0ms ease-in')),
    transition('collapse => open', animate('0ms ease-in')),
]);


export const animateText = trigger('animateText', [
    state('hide',
        style({
            'display': 'none',
            opacity: 0,
        })
    ),
    state('show',
        style({
            'display': 'block',
            opacity: 1,
            'margin-left': '10px'
        })
    ),
    transition('close => open', animate('350ms ease-in')),
    transition('open => close', animate('200ms ease-out')),
]);